// Imports
import ReactDOM from 'react-dom/client';
import App from './shareables/foundation/admin-ui/components/app';
import Tagline from './components/sidebar/tagline';
import WebsiteFunctionality from './components/resources/website-functionality';
import setUp from './shareables/foundation/front-end/utils/set-up';
import { Settings } from 'luxon';
import 'react-loading-skeleton/dist/skeleton.css';
import CustomizePageEditorUI from './components/resources/customize-page-editor-ui';
import CustomizeUserDropdown from './components/resources/customize-extra-user-dropdown-items';


// Set up
setUp();


// Fall back to U.S. English when the browser reports no locale
if (!new Intl.DateTimeFormat().resolvedOptions().locale) {
	Settings.defaultLocale = 'en-US';
}


// Disable Plausible if not in production
if (process.env.REACT_APP__ENVIRONMENT !== 'production') {
	localStorage.setItem('plausible_ignore', 'true');
}


// Create root
const container = document.getElementById('root');

if (!container) {
	throw new Error('Root container should exist');
}

const root = ReactDOM.createRoot(container);


// Mount & render
root.render(
	<App
		name='Admin Portal'
		tagline={<Tagline />}
		extraTopLevelComponents={[
			<WebsiteFunctionality key={0} />,
			<CustomizePageEditorUI key={1} />,
			<CustomizeUserDropdown key={2} />,
		]}
	/>
);
